import { DocumentObject, ItemList, SelectOptions } from '../../ApisForm.model';

export type DocumentationRequiredProps = {
	isInfant?: boolean;
};
export type OptionsOtherDocuments = {
	visa?: VisaOptions;
	others?: OthersOptions;
	showDivider: boolean;
	defaultVisa: VisaOptions;
};
export type OthersOptions = {
	otherDocsTypes: SelectOptions[];
	countries: SelectOptions[];
};
export type VisaOptions = {
	visaDocsTypes: SelectOptions;
	countries: SelectOptions[];
};
export type VisaDocumentProps = {
	options?: VisaOptions;
	isOptional?: boolean;
	isInfant?: boolean;
};
export type OthersDocumentProps = {
	options?: OthersOptions;
	isOptional?: boolean;
	config: DocumentObject[];
	isInfant?: boolean;
};

export type MandatoryDocumentProps = { isInfant?: boolean };

export type Document = {
	type: ItemList;
	issuedDate?: string;
	expiryDate?: string;
	number?: string;
	issuerCountry?: {
		code: string;
		description?: string;
	};
};

export type RequiredFieldTypesOrigin = 'NUM_DOC' | 'EXPIRY_DOC' | 'CNTRY_DOC';
export type RequiredFieldTypes = 'number' | 'expiryDate' | 'issuerCountry';

export type RequiredFieldOptions = {
	type?: RequiredFieldTypes;
	defaultValues?: SelectOptions;
	field: RequiredFieldTypesOrigin;
	values: string[];
};
export type DocumentForm = {
	type?: SelectOptions | string;
	number?: string;
	expiryDate?: string;
	issuerCountry?: SelectOptions | string;
	requiredField?: RequiredFieldTypesOrigin[];
};

export type FormDocumentationRequired = {
	mandatory: DocumentForm;
	visa?: DocumentForm;
	other?: DocumentForm;
};

export type ModelDocumentationRequired = {
	mandatory: DocumentObject[];
	other?: DocumentObject[];
};

export const REGEXP_DOCS = /^(?!.*[¡!?¿<>\\ºª|/·@#$%&,;=()_+{}\\[\]"^€£])/;
export const REGEXP_DNI = /^[XYZ]?([0-9]{7,8})([A-Z])$/i;
export const TYPE_CODE_DOCUMENT = {
	PSPT: 'PSPT',
	DNI: 'DNI',
	VISA: 'VISA',
	KNOWNTRAVELERNUMBER: 'KNOWNTRAVELERNUMBER',
	REDRESSNUMBER: 'REDRESSNUMBER',
	GREENCARD: 'GREENCARD'
};

export const REQUIRED_FIELD_TRANSFORMER = {
	NUM_DOC: 'number' as RequiredFieldTypes,
	CNTRY_DOC: 'issuerCountry' as RequiredFieldTypes,
	EXPIRY_DOC: 'expiryDate' as RequiredFieldTypes
};
export type RequiredField = {
	number: boolean;
	expiryDate: boolean;
	issuerCountry: boolean;
};
